import {Component} from "react";
import FullScreen from "./FullScreen.mjs";
import PropTypes from "prop-types";
import CloseIcon from "../../media/images/CloseIcon.mjs";
import "./FullScreenModal.css";

const prefix ="FullScreenModal";

const FullScreenModal = class extends Component {
	static propTypes = {
		className: PropTypes.string,
		style: PropTypes.object,
		backdrop: PropTypes.bool,
		toggle: PropTypes.func,
		title: PropTypes.any
	}
	constructor(props) {
		super(props);
		this.state = {
			className: prefix + ( this.props.className ? ' '+this.props.className : ''),
		}
		this.header = this.header.bind(this);
	}
	header() {
		if ( ! this.props.title && ! this.props.toggle ) return null;
		return (
			<div className={`${prefix}Header`}>
				<div className={`${prefix}Title`}>
					{ this.props.title ?? <span /> }
				</div>
				{ (typeof this.props.toggle==='function') && (
					<div className={`${prefix}Closer`} onClick={ this.props.toggle}>
						<CloseIcon />
					</div>
				)}
			</div>
		)
	}
	render() {
		return (
			<FullScreen
				className={this.state.className}
				style={this.props.style}
				backdrop={this.props.backdrop}
				toggle={this.props.toggle}
			>
				{ this.header() }
				<div className={`${prefix}Body`}>
					{ this.props.children }
				</div>
			</FullScreen>
		)
	}
}

export default FullScreenModal;